module.exports = __webpack_public_path__ + "img/pago-rechazado.b4d6a081.png";